export enum ProjectSMTPSecure {
    Tls = 'tls',
    Ssl = 'ssl',
}
